/**
 * Lean marketing-site entry — home paints without downloading app.js.
 */
import { applyWebpackPublicPath } from "./utils/webpackPublicPath";

applyWebpackPublicPath();

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

require("./components/LandingApp");
